import { COST_PRECISION } from "../domain/adaptComputedCost";

type FormatPriceStringConfig = {
  minimumFractionDigits: number;
  maximumFractionDigits: number;
};

export const formatPriceString = ({
  amount,
  config,
  unit = "€",
}: {
  amount?: number | null;
  config?: FormatPriceStringConfig;
  unit?: string;
}): string => {
  if (amount === undefined || amount === null) {
    const UNDEFINED_AMOUNT_FORMATTED = "-";

    return UNDEFINED_AMOUNT_FORMATTED;
  }

  return (
    amount.toLocaleString(
      "fr-FR",
      config
        ? config
        : {
            minimumFractionDigits: 0,
            maximumFractionDigits: COST_PRECISION,
          },
    ) + unit
  );
};

export const formatPrice = (
  amount?: number | null,
  unit: string = "€",
  config?: FormatPriceStringConfig,
) => {
  if (!amount) {
    return formatPriceString({ amount, unit, config });
  }

  return formatPriceString({ amount: amount / 100, unit, config });
};
